import React, { useEffect, useState } from "react";

// Components
import AlertTemplate from "~/common/components/AlertPortal/AlertTemplate";
import SingleImageUploader from "~/common/components/ImageUploader/SingleImageUploader";

//Assets
import "~/assets/sass/pages/mypage/admin/business.scss";
import "~/assets/sass/pages/mypage/admin/business/uncertified.scss";
import "~/assets/sass/pages/mypage/admin/business/certified.scss";
import "~/assets/sass/pages/mypage/admin/business/processing.scss";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { useTranslation } from "react-i18next";
import { UPLOAD_TYPE } from "~/common/constants/upload";

const Complete = ({ setStep, imageDone, info, edit, setCertImg }) => {
	const { t } = useTranslation();
	const [businessInfo, setBusinessInfo] = useState("");


	const [removeModal, setRemoveModal] = useState(false);


	useEffect(() => {
		info?.certificate?.imgUrl && setBusinessInfo(info?.certificate?.imgUrl)
	}, [info])

	useEffect(() => {
		(businessInfo && setCertImg) && setCertImg(businessInfo)
	}, [businessInfo])


	return (
		<>
			<div className="c__card certified">
				<div className="card-top">
					<dl className="content">
						<dt>{t("pages.myPage.admin.BusinessPage.Complete.dt")}</dt>
						<dd className="pre">{t("pages.myPage.admin.BusinessPage.Complete.dd")}</dd>
					</dl>
					<SingleImageUploader
						uploaderConstant={UPLOAD_TYPE.COMPANY_BUSINESS}
						img={businessInfo}
						setImg={setBusinessInfo}
						width={168}
						height={200}
						deletable
						onDelete={() => { setBusinessInfo(""); setCertImg("") }}
						readonly={!edit}
					/>
				</div>
				{/* {edit && <div className="card-bottom">
					<button
						type="button"
						className="btn__solid"
						color="gray"
						onClick={() => setRemoveModal(true)}
					>
						{t("pages.myPage.admin.BusinessPage.btn-cancel")}
					</button>
				</div>} */}
			</div>
			<AlertTemplate
				alertModalState={removeModal}
				setAlertModalToggle={setRemoveModal}
				alertType="warning"
				width={470}
				height={280}
			>
				<p className="alert-content">
					<div className="modal-text">
						{t("pages.myPage.admin.BusinessPage.modal-text")}
					</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
					// onClick={() => handleCancel(info.idx)}
					>
						{t("common.commonWord.button.yes")}
					</button>
					<button
						className="btn__solid"
						color="gray"
						onClick={() => setRemoveModal(false)}
					>
						{t("common.commonWord.button.no")}
					</button>
				</div>
			</AlertTemplate>
		</>
	);
};

export default Complete;
